<template>
  <div class="big-map-box">
    <div class="map-title">{{ title }}</div>
    <div class="full-map" id="fullMap"></div>
    <Bubble
      :bubbleData="bubbleData"
      :propertie="propertie"
      :itemList="itemList"
    />
    <div class="map-darkcorner"></div>
    <div @click="backProvince" class="backBtn" v-show="backBtnShow">返回</div>
    <div @click="layer.setFitView()" class="set-fitview" v-if="fitviewBtnFlag">归位</div>
    <ul :style="{ top: legendTop }" class="legend">
      <li :key="index" v-for="(item, index) of legendConf">
        <div
          :style="{ background: legendColor[index] }"
          class="color-box"
        ></div>
        <div class="text">
          {{
            item.max > 10000
              ? item.min / 10000 + "-" + item.max / 10000 + "万"
              : item.min + "-" + item.max
          }}
        </div>
      </li>
    </ul>
  </div>
</template>

<script>
/* eslint-disable */
import Bubble from './BorderMapComponent/Bubble'

export default {
  name: 'FullMap',
  components: {
    Bubble
  },
  props: {
    title: {
      type: String,
      default: ''
    },
    legendTop: {
      type: String,
      default: '70%'
    },
    areaCode: {
      type: String,
      default: ''
    },
    legendConf: {
      type: Array,
      default() {
        return []
      }
    },
    itemList: {
      type: Array,
      default() {
        return []
      }
    },
    mapData: {
      type: Array,
      default() {
        return []
      }
    }
  },
  data() {
    return {
      adcode: '',
      map: null,
      layer: null,
      fitviewBtnFlag: false,
      layerData: '',
      backBtnShow: false,
      timer: '',
      legendColor: ["#DA221A", "#FF852F", "#F5E047", "#6BF15c", "#34B7ED"],
      bubbleData: {
        // 标牌数据
        // touristVolume: '20000', // 游客量
        // visitors: '30000', // 游客人次
        // inflowVolume: '5000', // 流入量
        // outflowVolume: '4800' // 流出量
      },
      propertie: false
    }
  },
  mounted() {
    this.adcode = this.areaCode
    this.initChart()
    window.addEventListener('resize', this.resetMap)
  },
  destroyed() {
    window.removeEventListener('resize', this.resetMap)
  },
  methods: {
    initChart(getmap) {
      this.map = new AMap.Map('fullMap', {
        mapStyle: 'amap://styles/b5500447492ee5d38f79824b6e68aec4',
        zoom: 10
        //features: ["bg", "road"]
      })
      setInterval(() => {
        this.map.on('mapmove', () => {
          this.fitviewBtnFlag = true
        })
      }, 1000)
      if (this.layerData && !getmap) {
        this.initLayer()
        return
      }
      fetch('/area/' + this.adcode + '.json')
        .then(response => response.json())
        .then(data => {
          this.layerData = []
          for (var i = 0; i < data.features.length; i++) {
            if (!data.features[i].geometry) {
              continue
            }
            var temp = {}
            temp.name = data.features[i].properties.name
            temp.center = data.features[i].properties.center
            temp.coordinates = data.features[i].geometry.coordinates
            temp.adcode = data.features[i].properties.adcode
            temp.level = data.features[i].properties.level
            this.layerData.push(temp)
          }
          this.initLayer()
        })
    },
    initLayer() {
      this.layer = new Loca.PolygonLayer({
        map: this.map,
        fitView: true,
        eventSupport: true,
        zIndex: 1000
      })
      this.layer.setData(this.layerData, {
        lnglat: 'coordinates'
      })
      this.layer.setOptions({
        style: {
          color: '#00a4d6',
          opacity: 0.25,
          borderColor: '#3ad9ff',
          borderWidth: 2.5
        },
        selectStyle: {
          opacity: 0.5
        }
      })
      // 绑定事件
      this.layer.on('click', event => {
        if (event.rawData.level == 'district') {
          console.log('不能下钻到区县')
          return
        }
        this.backBtnShow = true
        this.adcode = event.rawData.adcode
        // 强制同步，避免出错
        setTimeout(() => {
          this.resetMap(true)
        }, 0)
        this.propertie = false
      })
      // 鼠标移上去显示标牌
      this.layer.on('mouseenter', event => {
        // 遍历拿标牌
        this.bubbleData = false
        for (let i = 0; i < this.mapData.length; i++) {
          if (this.mapData[i].code == event.rawData.adcode) {
            this.bubbleData = this.mapData[i]
          }
        }
        this.propertie = {
          geometryCenter: [
            event.originalEvent.clientX,
            event.originalEvent.clientY - 100
          ]
        }
      })
      this.layer.on('mouseleave', event => {
        this.propertie = false
      })
      this.layer.render()
      this.textLayer = new Loca.LabelsLayer({
        map: this.map,
        eventSupport: false, // 图层事件支持，LabelsLayer 默认开启
        fitView: true,
        // visible: true,
        collision: false // 是否开启文字自动避让
      })
      this.textLayer
        .setData(this.layerData, {
          lnglat: function(obj) {
            return [obj.value.center.lng, obj.value.center.lat]
          }
        })
        .setOptions({
          style: {
            zIndex: 9999,
            direction: 'right', // 文字位置
            offset: [-24, 24], // 文字偏移距离
            zooms: [3, 18], // 文字显示范围
            text: function(data) {
              return data.value.name
            }, // 文本内容
            fillColor: '#cbeeff', // 文字填充色
            fontSize: 12 // 文字大小, 默认值：12
          }
        })
        .render()
      this.iconLayer = new Loca.IconLayer({
        map: this.map,
        zIndex: 3000
      })
      this.iconLayer.setData(this.layerData, {
        lnglat: function(obj) {
          return [obj.value.center.lng, obj.value.center.lat]
        }
      })
      this.iconLayer.setOptions({
        source: res => {
          // 遍历比较 得到柱子图片
          var adcode = res.value.adcode
          var val = -1
          for (let i = 0; i < this.mapData.length; i++) {
            if (this.mapData[i].code == adcode) {
              val = this.mapData[i].valueList[0]
            }
          }
          
          if (val >= this.legendConf[0].min) {
            return '/img/light_bar5.png'
          } else if (val >= this.legendConf[1].min) {
            return '/img/light_bar4.png'
          } else if (val >= this.legendConf[2].min) {
            return '/img/light_bar3.png'
          } else if (val >= this.legendConf[3].min) {
            return '/img/light_bar2.png'
          } else if (val >= this.legendConf[4].min) {
            return '/img/light_bar1.png'
          }
        },
        style: {
          size: 22,
          opacity: 0.8
        }
      })
      this.iconLayer.render()
    },
    backProvince() {
      this.backBtnShow = false
      this.adcode = this.areaCode
      setTimeout(() => {
        this.resetMap(true)
      }, 0)
    },
    resetMap(getmap) {
      // 需要函数节流
      if (this.timer) {
        clearTimeout(this.timer)
      }
      this.timer = setTimeout(() => {
        if (!getmap) {
          this.map.destroy()
        }
        this.layer.off('click')
        this.layer.setMap(null)
        this.textLayer.setMap(null)
        this.iconLayer.setMap(null)
        this.initChart(getmap)
      }, 50)
    }
  }
}
</script>

<style scoped lang="less">
.big-map-box {
  .backBtn {
    position: absolute;
    left: 4.3rem;
    top: 1.24rem;
    box-sizing: border-box;
    width: 0.88rem;
    height: 0.26rem;
    padding-left: 0.26rem;
    background: url(../assets/backBtn.jpg);
    background-size: 100% 100%;
    color: @base-text-color;
    font-size: 0.16rem;
    line-height: 0.27rem;
    cursor: pointer;
  }
}
.full-map {
  width: 100%;
  height: 100%;
  position: absolute;
  top: 0;
  left: 0;
}
.legend {
  position: absolute;
  right: 4.5rem;
  padding: 0.2rem;
  background: rgba(0, 0, 0, 0.5);
}
.legend li {
  height: 0.26rem;
  color: @base-text-color;
}
.legend li .color-box {
  display: block;
  width: 0.12rem;
  height: 0.12rem;
  margin-top: 0.04rem;
  margin-right: 0.12rem;
  border-radius: 50%;
  background: #ccc;
}
.legend li > div {
  float: left;
}
@media screen and (max-height: 863px) {
  .legend {
    top: 6.8rem;
  }
}
</style>
